export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE_MB_FP = 30;
